export class ValoresPorMesAno {
  total: string;
  primeira_pontuacao_mes: Date;
  ultima_pontuacao_mes: Date;
}

export class RelatorioFaturamentoCartaoFidelidaeDetalhe {
  valorPeriodo: string;
  valorTotal: string;
  valoresPorMesAno: ValoresPorMesAno[];
}



